import styled from 'styled-components';
import fontSize from '../../../styles/settings/fontSize';
import colors from '../../../styles/settings/colors';

export const RightContainer = styled.div``;

export const MiddleTable = styled.div`
  .table {
    /* border-collapse: collapse; */
    font-size: ${fontSize.tableRowText}!important;
    width: auto;

    .react-bootstrap-table-sort-order,
    .order {
      display: none;
    }

    .sr-only {
      display: none;
    }

    .filter.text-filter {
      margin-left: 8px;
    }

    thead {
      tr {
        text-align: left;
      }
    }

    tbody {
      tr {
        cursor: pointer;
        td {
          box-sizing: border-box;
          white-space: nowrap;
        }
        td:nth-child(2) {
           width: 100%;
        }
      }
    }
  }

  &.search-proposes {
    tbody {
      tr {
        &:first-child {
          min-width: 380px;
          width: 50%;
        }
        &:nth-child(2) {
          width: 5%;
        }
        &:nth-child(3) {
         width: 100%;
        }
        &:nth-child(4) {
          width: 15%;
        }
        &:nth-child(5) {
          width: 15%;
        }
        cursor: pointer;
        td {
          white-space: nowrap;
        }
        td:nth-child(2) {
           width: 100%;
        }
      }
    }
  }

   &.proposes {
    tbody {
      tr {
        cursor: pointer;
        td {
          white-space: nowrap;
        }
        td:nth-child(2) {
          width: auto;
        }
        td:nth-child(3) {
          width: 100%;
        }
      }
    }
  }


  &.available-notes{
    tbody {
      tr {
        td:nth-child(1) {
           width: 100%;
        }
      }
    }
  }

  &.email-table {
    tbody {
      width: 100%;
      tr td {
        white-space: nowrap;
        &:nth-child(2) {
          width: 100%;
        }
        &:nth-child(3) {
          
        }
        &:nth-child(4) {
          
        }
        &:last-child {
          text-align: left;
          
        }
        cursor: pointer;
      }
    }
  }
  .react-bootstrap-table-sort-order,
  .order {
    display: none;
  }

  .sr-only {
    display: none;
  }

  .filter.text-filter {
    margin-left: 8px;
  }
  .react-bootstrap-table {
    bottom: 6px;
    position: relative;
    overflow: auto;
    & thead th {
      background: ${colors.sanMarino};
      color: ${colors.white};
      position: sticky;
      top: 0;
      z-index: 1;
    }
  }

  .fornecedor-header-with-filter {
    align-items: center;
    display: flex;
    gap: 0;
    justify-content: space-between;
    width: 100%;
  }

  .fornecedor-header-with-filter > span {
    padding-right: 8px;
    white-space: nowrap;
  }

  .fornecedor-header-with-filter .filter.text-filter {
    margin-left: 0;
    margin-bottom: 0;
    max-width: none;
    width: 100%;
  }

  .fornecedor-header-with-filter .form-control {
    background: #fff !important;
    border: 0 !important;
    border-left: 1px solid #d0d0d0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    color: #000;
    font-size: ${fontSize.tableRowText};
    height: 28px !important;
    line-height: 28px;
    padding: 0 8px;
  }

  .fornecedor-header-with-filter .form-control::placeholder {
    color: #9e9e9e;
    opacity: 1;
  }

  .fornecedor-header-with-filter .form-control:focus {
    outline: none;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: ${colors.oddColor};
  }

  .table-striped tbody tr:nth-of-type(even) {
    background-color: ${colors.evenColor};
  }

  > div {
    max-height: 480px;
  }
`;

export const TableTitleHeader = styled.div`
  align-items: center;
  background-color: ${colors.sanMarino};
  border-radius: 4px 4px 0 0;
  color: #fff;
  display: flex;
  flex-flow: row wrap;
  font-size: ${fontSize.button};
  font-weight: bold;
  justify-content: space-between;
  overflow: hidden !important;

  .operation-title {
    font-size: ${fontSize.headerTable};
    margin: 0 auto;
    padding: 4px 0;
  }

  svg {
    color: white;
    margin-right: 8px;
    width: 15px;
  }

  .anotation-body-header {
    background-color: ${colors.sanMarino};
    color: #fff;
    display: flex;
    font-size: ${fontSize.tableRowText};
    font-weight: bold;
    padding: 0 1px;
    width: calc(100% - 30px);

    span {
      border-right: 2px solid #fff;
    }
    span:first-child {
      width: 12%;
    }
    span.provider-field {
      width: 38%;
    }
    span.user-field {
      width: 37%;
    }
    span:last-child {
      border-right: 0 solid #fff;
      margin: 0 0 0 auto;
      width: 13%;
    }
  }
`;

export const ActionsButtons = styled.div``;

export const FilterOptions = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: 0 0 8px;

  .btn-search-actions {
    display: flex;
    flex-flow: column wrap;
    position: relative;
    bottom: 5px;
    .search-btn {
      align-self: end;
      font-size: ${fontSize.tableRowText};
      height: 30px;
      margin: 0 0 4px;
      width: 100px;
    }
  }
`;

export const ButtonsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: 0 0 8px;
`;

export const InputOptions = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: 0 8px 0 0;

  .MuiInputBase-root {
    background: ${colors.white};
    border: 1px solid ${colors.tundora};
    border-radius: 4px;
    font-size: ${fontSize.tableRowText};
    height: 30px;
    margin: 0 4px 4px;
    padding: 4px;
  }
  .input-column {
    margin: 0 0 8px;
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    width: 50%;

    .react-datepicker-wrapper {
      width: 45%;

      .last-date {
        position: relative;
        right: 18px;
        &.react-datepicker-ignore-onclickoutside {
          right: 0;
        }
      }

      input {
        background: #fff;
        border: 1px solid #424242;
        border-radius: 4px;
        font-size: ${fontSize.tableRowText};
        height: 19px;
        margin: 0 4px 4px;
        padding: 4px;
        width: 98%;
      }
    }
  }
  .w-50 {
    width: 45%;
  }
  .w-100 {
    width: 100%;
  }
`;

export const AnotationContainer = styled.div`
  /* box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%); */

  .operation-title {
    align-items: center;
    display: flex;
    font-size: ${fontSize.headerTable};
    margin: 0 auto;
  }

  button {
    margin-right: 8px;
  }

  span:first-child {
    width: 12%;
  }
  span.provider-field {
    width: 37%;
  }
  span.user-field {
    width: 37%;
  }
  span:last-child {
    border-right: 0 solid #fff;
    margin: 0 0 0 auto;
    width: 13%;
  }
`;

export const AnotationBody = styled.div`
  max-height: 440px;
  overflow: auto;

  .anotation-body-message {
    background: #fff;
    border-bottom: 1px solid #c4c4c4;
    padding: 0 1px;

    &:nth-of-type(odd) {
      background-color: ${colors.oddColor};
    }
    &:nth-of-type(even) {
      background-color: ${colors.evenColor};
    }
    .anotation-message-header {
      display: flex;
      font-size: ${fontSize.tableRowText};
      width: 100%;
    }
    p {
      font-size: ${fontSize.tableRowText};
      margin: 4px 0;
    }
  }
`;

export const IconSend = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  svg {
    width: 15px;
  }
`;
